<template lang="pug">
ext-button(
  v-bind="$props"
  :size="size"
  :factor="factor"
  :block="block"
  @click="$emit('click', $event)"
)
  slot
</template>

<script>
import ExtButton from '../../ext/Button.vue';

export default {
  components: {
    ExtButton,
  },

  props: {
    transform: {
      type: Boolean,
      default: true,
    },

    size: {
      type: String,
      default: 'small',
    },

    fill: {
      type: Boolean,
      default: true,
    },

    factor: {
      type: Number,
      default: 1.4,
    },

    wide: {
      type: Boolean,
      default: true,
    },

    block: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: '',
    },

    to: {
      type: [String, Object],
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// Default.vue?d160300a